import { Injectable } from '@angular/core';
import { ConversationChannel } from '@vendasta/conversation';
import { Observable, of } from 'rxjs';
import { ConversationDetail } from '../interface/conversation.interface';
import { AlertOptions, ConversationChannelService } from './conversation-channel.abstract';

@Injectable()
export class ConversationFacebookService extends ConversationChannelService {
  getChatComposerAlert(
    _partnerId: string,
    _accountGroupId: string,
    conversationDetail?: ConversationDetail,
    channels?: ConversationChannel[],
  ): Observable<AlertOptions | null> {
    if (
      conversationDetail?.conversation.channel === ConversationChannel.CONVERSATION_CHANNEL_FACEBOOK &&
      channels?.length === 0
    ) {
      return of({
        title: 'INBOX.SETTINGS.FACEBOOK_MESSENGER.ERRORS.CANNOT_SEND_MESSAGE',
        description: 'INBOX.SETTINGS.FACEBOOK_MESSENGER.ERRORS.CANNOT_SEND_MESSAGE_DESCRIPTION',
      });
    }
    return of(null);
  }
}
